<span *ngIf="begin">{{ begin }}</span>
<span *ngIf="decimal" class="decimal">{{ decimal }}</span>
<span *ngIf="end">{{ end }}</span>
